import * as Yup from "yup";

export const ChangePasswordScheme = Yup.object({
    currentPassword: Yup.string().min(6).required("Please enter your current password"),
    password: Yup.string().min(6).required("Please enter your password"),
    confirm_password: Yup.string()
        .required('Confirm password is required')
        .oneOf([Yup.ref("password"), null], "Password must match"),
});






